/** @format */

import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { interval, from, Observable, of, timer, throwError, Subject, combineLatest, forkJoin, EMPTY, concat } from 'rxjs';
import { delay, withLatestFrom, map, switchMap, catchError, mergeMap, concatMap, throttleTime, distinctUntilChanged } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import {
	ApplicationActionType,
	DelayedAction,
	DelayedActionBy1,
	GetProblems,
	GetProblemsSuccess,
	GetProblemsError,
	SetProblems,
	SetProblemMarkers,
	GetProblemContacts,
	GetProblemContactsSuccess,
	GetProblemContactsError,
	Heartbeat,
	HeartbeatSuccess,
	HeartbeatError,
	GetMenuOption,
	GetMenuOptionSuccess,
	GetMenuOptionError,
	SetMenuOption,
	GetActivities,
	SetActivities,
	AddActivity,
	AddActivitySuccess,
	AddActivityError,
	ToastUserNotification,
	AddProblem,
	SetNewCaseNo,
	ReassignProblem,
	ReassignProblemSuccess,
	ReassignProblemError,
	SetSelectedProblemType,
	GetAllProblemSubTypes,
	RedirectPath,
	GetProblemHistory,
	GetProblemHistorySuccess,
	GetProblemHistoryError,
	UpdateProblem,
	GetDescriptionHistory,
	SetDescriptionHistory,
	SetRapUsers,
	SetProblemContacts,
	UpdateActivity,
	UpdateContact,
	UpdateActivitySuccess,
	UpdateActivityError,
	SearchCoordinates,
	SearchCoordinatesSuccess,
	SearchCoordinatesError,
	SearchFromCoordinates,
	SearchFromCoordinatesError,
	SearchFromCoordinatesSuccess,
	Search,
	SaveSearchQuery,
	UpdateURLParams,
	SearchResultsSuccess,
	SearchResultsError,
	LookupOwner,
	LookupOwnerSuccess,
	LookupOwnerError,
	GetProblemAttachments,
	GetProblemAttachmentsSuccess,
	GetProblemAttachmentsError,
	UploadAttachments,
	DownloadEdocsFile,
	DeleteAttachment,
	UpdateAttachment,
	SetNewCaseMenu,
	SetNoProblems,
	AddProblemContacts,
	AddProblemContactsSuccess,
	AddProblemContactsError,
	DeleteContact,
	DeleteContactSuccess,
	DeleteContactError,
	DeletePhoneSuccess,
	DeletePhoneError,
	DeletePhone,
	UploadDocumentSuccess,
	UploadDocumentError,
	GetTask,
	GetTaskSuccess,
	GetTaskError,
	SetTasks,
	AddCodeCase,
	AddCodeCaseSuccess,
	AddCodeCaseError,
	CreatingCodeCase,
	SetSearchCoordinates,
	ScrollToResults,
	GoToProblemDetails,
	GetProblemAttachmentsImages,
	SetMenuDictionaries,
	SetZoneLookupOnly,
	SetProblemAttachmentsImages,
	GetProblemAttachmentsImagesPartialSuccess,
	GetProblemAttachmentsImagesError,
	RemoveProblemAttachmentsImages,
	RemoveProblemAttachments,
	GetActivity,
	GetTasks,
	UpdateActivityClose,
	SubmitWorkOrder,
	GetLayers,
	GetAsset,
	SetAsset,
	AddAsset,
	AddAssetSuccess,
	AddAssetError,
	SetInProgressActivity,
	SubmitWorkOrderSuccess,
	SubmitWorkOrderError,
	SetInProgressMyTask,
	DeleteWorkOrderByActivityId,
	DeleteWorkOrderByActivityIdSuccess,
	DeleteWorkOrderByActivityIdError,
	AddWorkOrder,
	AddWorkOrderSuccess,
	AddWorkOrderError,
	DeleteAsset,
	DeleteAssetSuccess,
	DeleteAssetError,
	CancelActivity,
	CancelActivityError,
	CancelActivitySuccess,
	SaveSearchQuerySuccess,
	SaveSearchQueryError,
	GetAllSearchQueries,
	GetAllSearchQueriesError,
	GetAllSearchQueriesSuccess,
	RemoveSavedSearchQuery,
	RemoveSavedSearchQuerySuccess,
	RemoveSavedSearchQueryError,
	GetDashboardView,
	SetDashboardView,
	GetDashboardViewError,
	GetDashboardViewSuccess,
	SaveDashboardViewSuccess,
	SaveDashboardView,
	SaveDashboardViewError,
	GetProblemNeighbors,
	GetProblemNeighborsSuccess,
	SetProblemNeighborScope,
	SetProblemNeighborScopeSuccess,
	UpdateProblemRead,
	AddPermit,
	AddPermitSuccess,
	AddPermitError,
	AddProblemLinkedCase,
	AddProblemLinkedCaseError,
	AddProblemLinkedCaseSuccess,
	GetProblemLinkedCases,
	GetProblemLinkedCasesError,
	GetProblemLinkedCasesSucccess,
	UnlinkProblemCase,
	UnlinkProblemCaseError,
	UnlinkProblemCaseSuccess,
	GetAllProblemLinkedCases,
	AddProblemLinkedCaseSuccessToastMsg,
	UpdateLinkedCaseNotes,
	UpdateLinkedCaseNotesError,
	UpdateLinkedCaseNotesSuccess,
	AddProblemLinkedCases,
	GetProblemLinkedCasesAddMenu,
	GetProblemLinkedCasesAddMenuError,
	GetProblemLinkedCasesAddMenuSucccess,
	GetDashBoardProblems,
	GetDashBoardProblemsSuccess,
	GetDashBoardProblemsError,
	SetDashBoardProblems,
	RenewArcGisToken,
	RenewArcGisTokenSuccess,
	RenewArcGisTokenError,
	DownloadAzureFile,
	IsNation,
	LookupOwnerAddress,
	UpdateUserError,
	SetIsAdminUser,
	GetIsAdminUser,
	GetUsers,
	SetUsers,
	UpdateUser,
	UpdateUserSuccess,
	AdminCreateNewUser,
	SetProfilePicture,
	SetGroups,
	SetRoles,
	UpdateGroupSuccess,
	GetRoles,
	UpdateGroup,
	UpdateGroupError,
	GetGroups,
	UpdateRoleError,
	UpdateRoleSuccess,
	UpdateRole,
	AdminCreateNewGroup,
	AdminCreateNewRole,
	SetADUsersList,
	SetRecentProblemsList,
	GetRecentProblemsList,
	GetSearchListLinkedCases,
	GetRecentProblemsListSuccess,
	GetRecentProblemsListError,
	DuplicateProblem,
	DuplicateProblemSuccess,
	DuplicateProblemError,
	CloseProblem,
	CloseProblemSuccess,
	CloseProblemError,
	SetAllProblemSubTypes,
	SetNoMapLocation,
	CityworksTransferRequest,
	TransferringToCityworks,
	CityworksTransferRequestSuccess,
	CityworksTransferRequestError,
	CityworksRequestView,
	CityworksRequestViewSuccess,
	CityworksRequestViewError,
	SetCityworksTransferMap,
} from './application.action';
import {
	UserNotification,
	MenuItem,
	User,
	LocationCoordinate,
	SearchCoordinatesPayload,
	prop,
	GetMenuOptionPayload,
	queryParameterNames,
	SearchResultsPayloadTypes,
	SearchLocation,
	ProblemType,
	LookupOwnerPayload,
	ProblemContactsPayload,
	HeartbeatPayload,
	SearchProblem,
	WorkOrder,
	Asset,
	SubmitWorkOrderPayload,
	SearchQuery,
	LinkedCase,
	LinkedCaseRelated,
	ArcGisToken,
	ArcGisTokenAboutToExpire,
	Group,
	Role,
	AdminUserView,
	SearchResultsPayload,
	ProblemSubType,
	SelectedProblemSubType,
	CityWorksRequestViewResponse,
	CityworksTransferMapping,
} from './application.state';
import {
	ActivityService,
	ProblemsService,
	LocationService,
	SearchService,
	WorkOrderService,
	ArcGisService,
	LayersService,
	AssetService,
	AdminService,
	CityworksService,
} from 'src/app/services';
import { History } from 'src/app/models/history';

import { State } from 'src/app/state-management';

import { DnvMarker, SetMarkers, DnvLatLng, DnvMapInfo, EditShapes, Layer, SetLayers, SetMapFeatureLayers, LayerState } from 'dnv-lib';
import { ActivityList, Activity, TaskList, TaskPayload } from 'src/app/models/activity';
import { Problem, getUserFromState, getGroupFromState, ContactDB, ProblemContact, getRoleFromState } from 'src/app/models/problem';
import { Router } from '@angular/router';
// import { setupRouter } from '@angular/router/src/router_module';

import { SearchItemType, SetMapGeoJsonLayers, ZoomToGeoJsonLayer, DnvMapActionType, SetArcGisToken } from 'dnv-lib';
import { UploadAttachmentsPayload, Attachment, EdocsDocument } from 'src/app/models/attachment';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxGalleryImage } from '@vinlos/ngx-gallery';

import robustPointInPolygon from 'robust-point-in-polygon';

import { MsalService } from '@azure/msal-angular';
import { b64toBlob } from 'src/app/utils/base64ToBlob';

@Injectable()
export class ApplicationEffects {
	private ngUnsubscribe: Subject<void> = new Subject();

	downloadEdocsFile$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(ApplicationActionType.DownloadEdocsFile),
				switchMap((action: DownloadEdocsFile) => {
					return this.problemsService.downloadEdocsFile(action.payload!).pipe(
						map((blob) => {
							const file = new Blob([blob], { type: 'application/octet-stream' });
							const link = document.createElement('a');
							link.href = window.URL.createObjectURL(file);
							link.download = action.payload! + '.' + blob.type.substring(blob.type.indexOf('/') + 1);
							link.click();
						}),
						catchError((error: HttpErrorResponse) => {
							return of(new GetProblemAttachmentsImagesError());
						}),
					);
				}),
			),
		{ dispatch: false },
	);

	downloadAzureFile$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(ApplicationActionType.DownloadAzureFile),
				switchMap((action: DownloadAzureFile) => {
					return this.problemsService.downloadAzureFile(action.payload!).pipe(
						map((blob) => {
							const file = new Blob([blob], { type: 'application/octet-stream' });
							const link = document.createElement('a');
							link.href = window.URL.createObjectURL(file);
							link.download = action.payload! + '.' + blob.type.substring(blob.type.indexOf('/') + 1);
							// Determine if browser is IE
							if (/msie\s|trident\//i.test(window.navigator.userAgent)) {
								(navigator as any).msSaveOrOpenBlob(blob, action.payload! + '.DRF');
							} else {
								link.click();
							}
						}),
						catchError((error: HttpErrorResponse) => {
							return of(new GetProblemAttachmentsImagesError());
						}),
					);
				}),
			),
		{ dispatch: false },
	);

	delayedAction$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DelayedAction),
			delay(0),
			mergeMap((action: DelayedAction) => {
				return action.payload!;
			}),
		),
	);

	delayedActionBy1$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DelayedActionBy1),
			delay(1000),
			mergeMap((action: DelayedActionBy1) => {
				return action.payload!;
			}),
		),
	);

	problemRead$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateProblemRead),
			switchMap((action: UpdateProblemRead) => {
				return this.problemsService.problemRead(action.payload!).pipe(
					map((data: number) => {
						return { response: data, problemNo: action.payload! };
					}),
					catchError((): any => {
						return [];
					}),
				);
			}),
			mergeMap((data: { response: number; problemNo: string }) => {
				const actions = [];
				if (data.response === 200) {
					actions.push(
						new ToastUserNotification({
							type: 'success',
							title: '',
							message: 'Viewed ' + data.problemNo,
							options: {
								disableTimeOut: false,
								closeButton: true,
								enableHtml: true,
								timeOut: 1500,
							},
						}),
					);
				}

				return actions;
			}),
		),
	);

	deleteAttachment$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteAttachment),
			switchMap((action: DeleteAttachment) => {
				return this.problemsService.deleteAttachment(action.payload?.attachmentId).pipe(
					map((data: Attachment) => {
						if (data.attachment_Id === action.payload?.attachmentId) {
							this.store$.dispatch(
								new ToastUserNotification({
									type: 'success',
									title: 'File Deleted',
									message: 'File ' + data.attachment_Name + ' was successfully deleted.',
									options: {},
								}),
							);
						}

						return data.docNumber.toString();
					}),
				);
			}),
			mergeMap((data) => {
				return [new RemoveProblemAttachmentsImages(data), new RemoveProblemAttachments(data)];
			}),
		),
	);

	getAllProblemLinkedCases$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetAllProblemLinkedCases),
			switchMap((action: GetAllProblemLinkedCases) => {
				return this.problemsService.getAllLinkedCases().pipe(
					map((data: LinkedCase[]) => {
						return new GetProblemLinkedCasesSucccess(data);
					}),
					catchError((error: any) => {
						return of(new GetProblemLinkedCasesError(error));
					}),
				);
			}),
		),
	);

	getSearchListLinkedCases$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetSearchListLinkedCases),
			switchMap((action: GetSearchListLinkedCases) => {
				return this.problemsService.getSearchListLinkedCases(action.payload).pipe(
					map((data: LinkedCase[]) => {
						return new GetProblemLinkedCasesSucccess(data);
					}),
					catchError((error: any) => {
						return of(new GetProblemLinkedCasesError(error));
					}),
				);
			}),
		),
	);

	getProblemLinkedCases$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemLinkedCases),
			switchMap((action: GetProblemLinkedCases) => {
				return this.problemsService.getProblemLinkedCases(action.payload?.caseNo).pipe(
					map((data: LinkedCase[]) => {
						return new GetProblemLinkedCasesSucccess(data);
					}),
					catchError((error: any) => {
						return of(new GetProblemLinkedCasesError(error));
					}),
				);
			}),
		),
	);

	getProblemLinkedCasesError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemLinkedCasesError),
			mergeMap((action: GetProblemLinkedCasesError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to retrieve linked cases.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getProblemLinkedCasesAddMenu$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemLinkedCasesAddMenu),
			switchMap((action: GetProblemLinkedCasesAddMenu) => {
				return this.problemsService.getProblemLinkedCasesAddMenu(action.payload?.caseNo, action.payload?.searchCaseNo).pipe(
					map((data: LinkedCaseRelated) => {
						return new GetProblemLinkedCasesAddMenuSucccess(data);
					}),
					catchError((error: any) => {
						return of(new GetProblemLinkedCasesError(error));
					}),
				);
			}),
		),
	);

	getProblemLinkedCasesAddMenuError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemLinkedCasesAddMenuError),
			mergeMap((action: GetProblemLinkedCasesAddMenuError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to retrieve linked cases.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	addProblemLinkedCase$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblemLinkedCase),
			switchMap((action: AddProblemLinkedCase) => {
				const caseNo = action.payload?.caseNo;
				return this.problemsService.addProblemLinkedCase(action.payload!).pipe(
					map((data: LinkedCase[]) => {
						return new AddProblemLinkedCaseSuccess({ caseNo: caseNo, linkedCase: data });
					}),
					catchError((error: any) => {
						return of(new AddProblemLinkedCaseError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	addProblemLinkedCases$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblemLinkedCases),
			switchMap((action: AddProblemLinkedCases) => {
				return this.problemsService.addProblemLinkedCases(action.payload!).pipe(
					map((data: LinkedCase[]) => {
						return new AddProblemLinkedCaseSuccess({ linkedCase: data });
					}),
					catchError((error: any) => {
						return of(new AddProblemLinkedCaseError());
					}),
				);
			}),
		),
	);

	addProblemLinkedCaseSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblemLinkedCaseSuccess),
			mergeMap((action: AddProblemLinkedCaseSuccess) => {
				if (window.location.pathname === '/dashboard') {
					const actions: Action[] = [
						new GetProblems(),
						new AddProblemLinkedCaseSuccessToastMsg({ caseNo: action.payload?.caseNo, msg: 'RAP' }),
					];

					return actions;
				}

				return of(new AddProblemLinkedCaseSuccessToastMsg({ caseNo: action.payload?.caseNo, msg: 'RAP' }));
			}),
		),
	);

	addProblemLinkedCaseSuccessToastMsg$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblemLinkedCaseSuccessToastMsg),
			mergeMap((action: AddProblemLinkedCaseSuccessToastMsg) => {
				const title = action.payload?.msg === 'Energov' ? 'Energov Case Successfully Linked' : 'Problems Successfully Linked';

				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: title,
						message: 'View in Linked Cases section of the Problem Detail page',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				if (action.payload?.caseNo) {
					actions.push(new GetProblems({ problemNo: action.payload?.caseNo }));
				}

				return actions;
			}),
		),
	);

	addProblemLinkedCaseError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblemLinkedCaseError),
			mergeMap((action: AddProblemLinkedCaseError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: 'Failed To Link Problems',
						message: action.payload?.error ? action.payload?.error.error : 'Failed to link the case to the current problem.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	unlinkProblemCase$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UnlinkProblemCase),
			switchMap((action: UnlinkProblemCase) => {
				return this.problemsService.unlinkProblemCase(action.payload!).pipe(
					map((data: any) => {
						return new UnlinkProblemCaseSuccess(data);
					}),
					catchError((error: any) => {
						return of(new UnlinkProblemCaseError(action.payload!));
					}),
				);
			}),
		),
	);

	unlinkProblemCaseSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UnlinkProblemCaseSuccess),
			mergeMap((action: UnlinkProblemCaseSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'The case has been successfully unlinked.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	unlinkProblemCaseError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UnlinkProblemCaseError),
			mergeMap((action: UnlinkProblemCaseError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'The case failed to unlink from the problem.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	updateLinkedCaseNotes = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateLinkedCaseNotes),
			switchMap((action: UpdateLinkedCaseNotes) => {
				return this.problemsService.updateLinkedCaseNote(action.payload!).pipe(
					map((data: LinkedCase) => {
						return new UpdateLinkedCaseNotesSuccess(data);
					}),
					catchError((error: any) => {
						return of(new UpdateLinkedCaseNotesError(action.payload!));
					}),
				);
			}),
		),
	);

	updateLinkedCaseNotesSuccess = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateLinkedCaseNotesSuccess),
			mergeMap((action: UpdateLinkedCaseNotesSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'The case notes were successfully updated.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	updateLinkedCaseNotesError = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateLinkedCaseNotesError),
			mergeMap((action: UpdateLinkedCaseNotesError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'The case notes failed to update.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	deletePhone$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeletePhone),
			switchMap((action: DeletePhone) => {
				return this.problemsService.deletePhone(action.payload?.id, action.payload?.problem_Id).pipe(
					map((data: any) => {
						// action.payload?.success = data;
						return new DeletePhoneSuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new DeletePhoneError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	deletePhoneSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeletePhoneSuccess),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [DeletePhoneSuccess, State]) => {
				const problemNo = store.applicationReducer.problems.find((p) => p.problemId === action.payload?.problem_Id)!.problemNo;
				const actions: Action[] = [
					new GetProblems({ problemNo: problemNo }),
					new SetProblemContacts(action.payload?.success),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Phone number has been deleted.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	deletePhoneError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeletePhoneError),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [DeletePhoneError, State]) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to delete Phone number.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	heartbeat$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.Heartbeat),
			switchMap((action: Heartbeat) => {
				return this.problemsService.heartbeat().pipe(
					map((data: any) => {
						return new HeartbeatSuccess(action.payload!);
					}),
					catchError((error: any) => {
						return of(new DelayedActionBy1([new HeartbeatError(action.payload!)]));
					}),
				);
			}),
		),
	);

	heartbeatSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.HeartbeatSuccess),
			mergeMap((action: HeartbeatSuccess) => {
				return action.payload?.actions;
			}),
		),
	);

	heartbeatError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.HeartbeatError),
			mergeMap((action: HeartbeatError) => {
				return of(
					new Heartbeat({
						actions: action.payload?.actions,
						retryCount: action.payload?.retryCount + 1,
						maxRetry: action.payload?.maxRetry,
					}),
				).pipe(delay((action.payload?.retryCount + 1) * 1000));
			}),
			mergeMap((action: Heartbeat) => {
				const actions: Action[] = [];

				if (action.payload?.retryCount >= action.payload?.maxRetry) {
					actions.push(
						new ToastUserNotification({
							type: 'error',
							title: 'The operation failed',
							message: 'To continue, please refresh this page first by pressing Ctrl-Shift-R.',
							options: {
								disableTimeOut: true,
								closeButton: true,
								enableHtml: true,
								timeOut: 5000,
							},
						}),
					);
				} else {
					actions.push(
						new ToastUserNotification({
							type: 'warning',
							title: 'Please wait!',
							message: 'We are experiencing delays renewing your access token and will retry shortly.',
							options: {
								disableTimeOut: false,
								closeButton: true,
								enableHtml: true,
								timeOut: action.payload?.retryCount * 1000,
							},
						}),
					);
				}
				actions.push(action);
				return actions;
			}),
		),
	);

	GetIsAdminUser$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetIsAdminUser),
			switchMap((action: GetIsAdminUser) => {
				return this.adminService.getIsAdmin().pipe(
					map((data: any) => {
						// TODO: add new success / error actions for isAdminUser
						return new SetIsAdminUser(data);
					}),
					catchError((error: any) => {
						return of(null);
					}),
				);
			}),
		),
	);

	GetUsers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetUsers),
			switchMap((action: GetUsers) => {
				return this.adminService.getUsers().pipe(
					map((data: AdminUserView[]) => {
						let usersList: AdminUserView[] = [];
						data.forEach((user) => {
							usersList.push({
								user_Id: user.user_Id,
								firstName: user.firstName || '',
								lastName: user.lastName || '',
								email: user.email || '',
								active: user.active,
								upn: user.upn || '',
								groupSelections: user.groupSelections,
								groupNamesStr: '',
								roleSelections: user.roleSelections,
								roleNamesStr: '',
								edocsAlias: user.edocsAlias || '',
							});
						});

						return new SetUsers(usersList.sort((a, b) => a.firstName.localeCompare(b.lastName)));
					}),
					catchError((error: any) => {
						return of(null);
					}),
				);
			}),
		),
	);

	GetGroups$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetGroups),
			switchMap(() => {
				return this.adminService.getGroups().pipe(
					map((data: Group[]) => {
						return new SetGroups(data.sort((a, b) => a.name.localeCompare(b.name)));
					}),
					catchError((error: any) => {
						return of(null);
					}),
				);
			}),
		),
	);

	GetRoles$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetRoles),
			switchMap(() => {
				return this.adminService.getRoles().pipe(
					map((data: Role[]) => {
						return new SetRoles(data.sort((a, b) => a.name.localeCompare(b.name)));
					}),
					catchError((error: any) => {
						return of(null);
					}),
				);
			}),
		),
	);

	UpdateUser$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateUser),
			switchMap((action: UpdateUser) => {
				return this.adminService.updateUser(action.payload).pipe(
					map((data: any) => {
						return new UpdateUserSuccess(action.payload);
					}),
					catchError((error: any) => {
						return of(new UpdateUserError(action.payload));
					}),
				);
			}),
		),
	);

	UpdateUserSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateUserSuccess),
			mergeMap((action: UpdateUserSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'User <strong>' + action.payload.firstName + ' ' + action.payload.lastName + '</strong> was updated',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new GetUsers(),
				];

				return actions;
			}),
		),
	);

	UpdateUserError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateUserError),
			mergeMap((action: UpdateUserError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message:
							'There was a problem updating user <strong>' + action.payload.firstName + ' ' + action.payload.lastName + '</strong>.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	UpdateGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateGroup),
			switchMap((action: UpdateGroup) => {
				return this.adminService.updateGroup(action.payload).pipe(
					map((data: any) => {
						return new UpdateGroupSuccess(action.payload);
					}),
					catchError((error: any) => {
						return of(new UpdateGroupError(action.payload));
					}),
				);
			}),
		),
	);

	UpdateGroupSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateGroupSuccess),
			mergeMap((action: UpdateGroupSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Group <strong>' + action.payload.name + '</strong> was updated',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new GetGroups(),
				];

				return actions;
			}),
		),
	);

	UpdateGroupError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateGroupError),
			mergeMap((action: UpdateGroupError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message:
							'There was a problem updating Group <strong>' + action.payload.firstName + ' ' + action.payload.lastName + '</strong>.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	UpdateRole$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateRole),
			switchMap((action: UpdateRole) => {
				return this.adminService.updateRole(action.payload).pipe(
					map((data: any) => {
						return new UpdateRoleSuccess(action.payload);
					}),
					catchError((error: any) => {
						return of(new UpdateRoleError(action.payload));
					}),
				);
			}),
		),
	);

	UpdateRoleSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateRoleSuccess),
			mergeMap((action: UpdateRoleSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Role <strong>' + action.payload.name + '</strong> was updated',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new GetRoles(),
				];

				return actions;
			}),
		),
	);

	UpdateRoleError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateRoleError),
			mergeMap((action: UpdateRoleError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message:
							'There was a problem updating Role <strong>' + action.payload.firstName + ' ' + action.payload.lastName + '</strong>.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getMenuOption$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetMenuOption),
			switchMap((action: GetMenuOption) => {
				return this.problemsService.getMenuOptions().pipe(
					map((data: any) => {
						// action.payload?.success = data;
						return new GetMenuOptionSuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new GetMenuOptionError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	getMenuOptionSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetMenuOptionSuccess),
			mergeMap((action: GetMenuOptionSuccess) => {
				const users = this.setUserMap(action.payload?.success!);
				return [new SetMenuOption(action.payload?.success), new SetMenuDictionaries(action.payload?.success), new SetRapUsers(users)];
			}),
		),
	);

	getMenuOptionError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetMenuOptionError),
			mergeMap((action: GetMenuOptionError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: 'Please refresh this page',
						message: 'Failed to load menu options.',
						options: {
							disableTimeOut: true,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getLayers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetLayers),
			switchMap((action: GetLayers) => this.layerService.getLayers()),
			// tslint:disable-next-line: deprecation
			mergeMap((data: Layer[]) => [new SetLayers(data)]),
		),
	);

	checkLayerDisplayEffect$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CheckLayerDisplay),
			withLatestFrom(this.store$),
			map(([, store]) => {
				return this.layerList(store.mapState.zoomLevel, store.layerState);
			}),
			mergeMap((layers) => [new SetMapFeatureLayers(layers)]),
		),
	);

	SetProblemNeighborScope$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SetProblemNeighborScope),
			switchMap((action: SetProblemNeighborScope) => {
				sessionStorage.setItem('problemNeighbors', JSON.stringify(action.payload?.problemNeighborScope));
				return of(new SetProblemNeighborScopeSuccess(action.payload!));
			}),
		),
	);

	GetProblemNeighbors$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemNeighbors),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [GetProblemNeighbors, State]) => {
				let data: string[] = store.applicationReducer.problemNeighborScope;
				if (data.length === 0) {
					const sessionNeighborStr = sessionStorage.getItem('problemNeighbors');
					if (!!sessionNeighborStr) {
						data = JSON.parse(sessionNeighborStr);
					}
				}

				const targetProblemIndex = data.findIndex((problemNo) => problemNo === action.payload?.problemNo);
				let nextProblem = '';
				let previousProblem = '';

				if (targetProblemIndex !== -1) {
					if (targetProblemIndex < data.length - 1) {
						nextProblem = data[targetProblemIndex + 1];
					}

					if (targetProblemIndex > 0) {
						previousProblem = data[targetProblemIndex - 1];
					}
				}

				const neighbors: string[] = [nextProblem, previousProblem];
				return of(new GetProblemNeighborsSuccess(Object.assign({}, action.payload!, { success: neighbors })));
			}),
		),
	);

	GetRecentProblemsList$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetRecentProblemsList),
			switchMap(() => {
				return this.problemsService.getRecentProblems().pipe(
					map((data: Problem[]) => {
						return new GetRecentProblemsListSuccess(data);
					}),
					catchError((error) => {
						let actions: Action[] = [new GetRecentProblemsListError(error)];

						return actions;
					}),
				);
			}),
		),
	);

	getRecentProblemsSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetRecentProblemsListSuccess),
			mergeMap((action: GetRecentProblemsListSuccess) => {
				const actions: Action[] = [new SetRecentProblemsList(action.payload), new SetNoProblems(false)];

				return actions;
			}),
		),
	);

	getRecentProblemsError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetRecentProblemsListError),
			mergeMap((action: GetRecentProblemsListError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: 'Failed to get recent cases',
						message: action.payload.error,
						options: {
							disableTimeOut: true,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getProblems$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblems),
			switchMap((action: GetProblems) => {
				const problems: Observable<Problem[]> = action.payload?.problemNo
					? this.problemsService.getProblem(action.payload.problemNo)
					: this.problemsService.getProblems();

				return problems.pipe(
					switchMap((data: Problem[]) => {
						if (!action.payload?.problemNo) {
							let linkedCases: LinkedCase[] = [];
							data.forEach((problem) => linkedCases.push(...problem.linkedCases));
							data.map((d) => {
								d.reportedDate = new Date(d.reportedDate);
							});
							let actions: Action[] = [
								new GetProblemsSuccess(Object.assign({}, action.payload!, { success: data })),
								new GetProblemLinkedCasesSucccess(linkedCases),
							];

							return actions;
						}

						return [new GetProblemsSuccess(Object.assign({}, action.payload!, { success: data }))];
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new GetProblemsError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	getProblemsSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemsSuccess),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [GetProblemsSuccess, State]) => {
				const actions: Action[] = [];

				//Set problem for problem details
				if (action.payload?.success!.length === 1 && store.applicationReducer.problems.length === 1) {
					actions.push(new SetProblems(action.payload?.success));
				}
				//Set Problems for dashboard
				else if (action.payload?.success!.length >= 1 && store.applicationReducer.problems.length !== action.payload?.success!.length) {
					actions.push(new SetProblems(action.payload?.success));
				} else if (action.payload?.success!.length === 0) {
					actions.push(new SetProblems(action.payload?.success));
				}

				if (store.applicationReducer.noProblems) {
					actions.push(new SetNoProblems(false));
				}

				if ('' !== action.payload?.problemNo && 1 === action.payload?.success!.length) {
					actions.push(new GetProblemContacts({ problemNo: action.payload?.problemNo }));
				}

				return actions;
			}),
		),
	);

	getProblemsError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemsError),
			mergeMap((action: GetProblemsError) => {
				let msg = 'Failed to load problem(s).';
				let title = 'Please refresh this page';
				if (action.payload?.error?.status === 404) {
					title = 'There has been an error';
					msg = 'The problem number does not exist';
				}
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: title,
						message: msg,
						options: {
							disableTimeOut: true,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new SetNoProblems(true),
					new SetProblems([]),
				];

				return actions;
			}),
		),
	);

	getDashBoardProblems$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetDashBoardProblems),
			switchMap(
				(action: GetDashBoardProblems): Observable<GetDashBoardProblemsSuccess | GetDashBoardProblemsError | any> => {
					if (action.payload?.problemNo !== undefined) {
						const problems: Observable<Problem[]> = this.problemsService.getDashboardProblems();

						return problems.pipe(
							map((data: Problem[]) => {
								// action.payload?.success = data;
								return new GetDashBoardProblemsSuccess(Object.assign({}, action.payload!, { success: data }));
							}),
							catchError((error: any) => {
								// action.payload?.error = error;
								return of(new GetDashBoardProblemsError(Object.assign({}, action.payload!, { error: error })));
							}),
						);
					} else {
						return [] as any;
					}
				},
			),
		),
	);

	getDashBoardProblemsSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetDashBoardProblemsSuccess),
			mergeMap((action: GetDashBoardProblemsSuccess) => {
				let problemList: string[] = [];

				if (action.payload?.success) {
					problemList = action.payload?.success.map((p) => {
						const location = p.problemLocation ? ' ' + p.problemLocation : '';
						return p.problemNo + location;
					});
				}
				const actions: Action[] = [new SetDashBoardProblems(problemList)];

				return actions;
			}),
		),
	);

	getDashBoardProblemsError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetDashBoardProblemsError),
			mergeMap((action: GetDashBoardProblemsError) => {
				let msg = 'Failed to load problem(s).';
				let title = 'Please refresh this page';
				if (action.payload?.error?.status === 404) {
					title = 'There has been an error';
					msg = 'The problem number does not exist';
				}
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: title,
						message: msg,
						options: {
							disableTimeOut: true,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new SetNoProblems(true),
					new SetProblems([]),
				];

				return actions;
			}),
		),
	);

	getProblemContacts$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemContacts),
			switchMap((action: GetProblemContacts) => {
				return this.problemsService.getProblemContacts(action.payload?.problemNo!).pipe(
					map((data: any) => {
						// action.payload?.success = data;
						return new GetProblemContactsSuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new GetProblemContactsError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	getProblemContactsSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemContactsSuccess),
			mergeMap((action: GetProblemContactsSuccess) => {
				return [new SetProblemContacts(action.payload?.success)];
			}),
		),
	);

	getProblemContactsError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemContactsError),
			mergeMap((action: GetProblemContactsError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to load problem contacts.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getNewCaseMenu$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetNewCaseMenu),
			switchMap(() => this.problemsService.getNewCaseMenu()),
			mergeMap((data) => [new SetNewCaseMenu(data)]),
		),
	);

	// @Effect()
	// listenToSetProblem$ = this.actions$.pipe(
	//   ofType(ApplicationActionType.SetProblems),
	//   delay(2222), // TODO temporary to give time to the browser to finish loading the map resources before placing the markers
	//   withLatestFrom(this.store$),
	//   switchMap(
	//     ([, store]) => {
	//       const problems = store.applicationReducer.problems;
	//       const appProbs = this.setMarkersInfo(problems, store.applicationReducer.menu.allProblemTypeList, true);
	//       return of(new SetMarkers(appProbs));
	//     })
	// );

	SetProblemMarkers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SetProblemMarkers),
			withLatestFrom(this.store$),
			map(([action, store]) =>
				this.setMarkersInfo(
					(action as SetProblemMarkers).payload!.problem,
					store.applicationReducer.menu.allProblemTypeList,
					(action as SetProblemMarkers).payload!.showToolTip,
				),
			),
			mergeMap((data: any) => {
				return [new SetMarkers(data)];
			}),
		),
	);

	getActivities$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetActivities),
			switchMap((action: GetActivities) => this.activityService.getActivityById(action.payload!)),
			mergeMap((data: ActivityList[]) => [new SetActivities(data)]),
		),
	);

	getActivity$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetActivity),
			switchMap((action: GetActivity) => this.activityService.getActivityByActivityNo(action.payload!)),
			mergeMap((data: ActivityList[]) => [new SetActivities(data)]),
		),
	);

	getAsset$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetAsset),
			switchMap((action: GetAsset) => this.assetService.getAssets()),
			mergeMap((data: Asset[]) => [new SetAsset(data)]),
		),
	);

	getTask$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetTask),
			switchMap((action: GetTask) =>
				this.activityService.getTask(action.payload?.activityNo!).pipe(
					map((data: TaskList) => {
						const taskPayload: TaskPayload = {};
						taskPayload.success = [data];
						return new GetTaskSuccess(taskPayload);
					}),
					catchError((error: any) => {
						return of(new GetTaskError(error));
					}),
				),
			),
		),
	);

	getTasks$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetTasks),
			switchMap((action: GetTasks) =>
				this.activityService.getTasks().pipe(
					map((data: TaskList[]) => {
						const taskPayload: TaskPayload = {};
						taskPayload.success = data;
						return new GetTaskSuccess(taskPayload);
					}),
					catchError((error: any) => {
						return of(new GetTaskError(error));
					}),
				),
			),
		),
	);

	getTaskSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetTaskSuccess),
			switchMap((action: GetTaskSuccess) => [new SetTasks(action.payload?.success)]),
		),
	);

	getTaskError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetTaskError),
			switchMap((action: GetTaskError) => {
				const actions = [
					new ToastUserNotification({
						type: 'error',
						title: 'Error',
						message: 'An error occured while trying to retrieve tasks. Please try again.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							timeOut: 3000,
						},
					}),
				];
				return actions;
			}),
		),
	);

	addActivity$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddActivity),
			concatMap((action: AddActivity) => {
				return this.activityService.addActivities(action.payload?.activity).pipe(
					map((data: ActivityList) => {
						// action.payload?.success = data;
						return new AddActivitySuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new AddActivityError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
			// concatMap((action: AddActivity) =>
			//   this.activityService.addActivities(action.payload!)
			// ),
			// withLatestFrom(this.store$),
			// mergeMap(([newActivity, store]: [ActivityList, State]) => [
			//   new SetActivity(newActivity),
			//   // new GetProblems(store.routerReducer.state.queryParams.ProblemNo), ???
			//   new ToastUserNotification({
			//     type: 'success',
			//     title: '',
			//     message: 'Activity is successfully added.',
			//     options: {
			//       disableTimeOut: false,
			//       closeButton: true,
			//       enableHtml: true,
			//       timeOut: 5000
			//     }
			//   })
			// ])
		),
	);

	addActivitySuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddActivitySuccess),
			mergeMap((action: AddActivitySuccess) => {
				const actions: Action[] = [
					new GetProblems({ problemNo: action.payload?.caseNumber }), // To update the last updated at / by info
					new GetActivities(action.payload?.caseNumber),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Activity is successfully added.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	addActivityError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddActivityError),
			mergeMap((action: AddActivityError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to create new activity.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	addAsset$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddAsset),
			concatMap((action: AddAsset) => {
				return this.assetService.addAsset(action.payload?.asset).pipe(
					map((data: Asset) => {
						// action.payload?.success = data;
						return new AddAssetSuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new AddAssetError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	addAssetSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddAssetSuccess),
			mergeMap((action: AddAssetSuccess) => {
				const actions: Action[] = [
					new GetAsset(),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Successfully added asset: ' + action.payload?.success!.gisAssetId,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new CreatingCodeCase(false),
				];

				return actions;
			}),
		),
	);

	addAssetError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddAssetError),
			mergeMap((action: AddAssetError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to add asset. ' + action.payload?.error!.error,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new CreatingCodeCase(false),
				];

				return actions;
			}),
		),
	);

	deleteAsset$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteAsset),
			concatMap((action: DeleteAsset) => {
				return this.assetService.deleteAsset(action.payload?.asset).pipe(
					map((data: Asset) => {
						return new DeleteAssetSuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						return of(new AddAssetError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	deleteAssetSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteAssetSuccess),
			mergeMap((action: DeleteAssetSuccess) => {
				const actions: Action[] = [
					new GetAsset(),
					new GetLayers(),
					new SetMapFeatureLayers([]),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Successfully deleted asset: ' + action.payload?.success!.gisAssetId,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new GetProblems({ problemNo: action.payload?.caseNo }),
				];

				return actions;
			}),
		),
	);

	deleteAssetError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteAssetError),
			mergeMap((action: DeleteAssetError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to delete asset. ' + action.payload?.error!.error,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getADUsersList$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetADUsersList),
			switchMap(() => {
				let request = {
					scopes: ['User.ReadBasic.All'],
					account: this.authService.instance.getActiveAccount(),
				};

				return from(this.authService.instance.acquireTokenSilent(request));
			}),
			switchMap((token: any) => {
				return from(this.adminService.getADUsers(token.accessToken));
			}),
			switchMap((response: any) => {
				let usersList: AdminUserView[] = [];
				(response.value || [response] || []).forEach((userEntry: any) => {
					if (userEntry.givenName && userEntry.surname && userEntry.mail && userEntry.userPrincipalName) {
						usersList.push({
							firstName: userEntry.givenName,
							lastName: userEntry.surname,
							email: userEntry.mail,
							active: false,
							upn: userEntry.userPrincipalName,
							groupSelections: [],
							roleSelections: [],
							edocsAlias: '',
						});
					}
				});

				return of(new SetADUsersList(usersList));
			}),
			catchError((error: any) => {
				console.log(error);
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to retrieve AD users list.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new SetADUsersList([]),
				];
				return actions;
			}),
		),
	);

	getProfilePicture$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProfilePicture),
			switchMap(() => {
				const account = (this.authService.instance.getActiveAccount()
					? this.authService.instance.getActiveAccount()
					: this.authService.instance.getAllAccounts().filter((a) => !a.username.match(/adm@/i))[0])!;

				const request = {
					scopes: ['User.Read'],
					account,
				};

				return from(this.authService.instance.acquireTokenSilent(request)).pipe(
					map((token: any) => {
						return { token };
					}),
				);
			}),
			switchMap((token: any) => {
				return from(this.problemsService.getProfilePicture(token.accessToken));
			}),
			switchMap((response: any) => {
				return of(new SetProfilePicture(response));
			}),
			catchError((error: any) => {
				console.log(error);
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to retrieve profile photo.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new SetProfilePicture(null),
				];
				return actions;
			}),
		),
	);

	adminCreateNewUser$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AdminCreateNewUser),
			switchMap((action: AdminCreateNewUser) => {
				return this.adminService.createUser(action.payload).pipe(
					mergeMap((users: User[]) => {
						const actions: Action[] = [
							new ToastUserNotification({
								type: 'success',
								title: 'User Creation Success',
								message: `User ${action.payload.firstName} ${action.payload.lastName} successfully created.`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									enableHtml: true,
									timeOut: 5000,
								},
							}),
							new SetUsers(users),
						];

						return actions;
					}),
					catchError((error: any) => {
						console.log(error);
						let title = 'User Creation Error';

						if (error.status) {
							switch (error.status) {
								case 409:
									title = 'User Creation Error: Entry Conflict';
									break;

								default:
									break;
							}
						}

						return [
							new ToastUserNotification({
								type: 'error',
								title: title,
								message: error.error,
								options: {
									disableTimeOut: false,
									closeButton: true,
									enableHtml: true,
									timeOut: 5000,
								},
							}),
						];
					}),
				);
			}),
		),
	);

	adminCreateNewGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AdminCreateNewGroup),
			switchMap((action: AdminCreateNewGroup) => {
				return this.adminService.createGroup(action.payload).pipe(
					mergeMap((groups: Group[]) => {
						const actions: Action[] = [
							new ToastUserNotification({
								type: 'success',
								title: '',
								message: `Group ${action.payload.name} was successfully created.`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									enableHtml: true,
									timeOut: 5000,
								},
							}),
							new SetGroups(groups),
						];

						return actions;
					}),
					catchError((error: any) => {
						return [
							new ToastUserNotification({
								type: 'error',
								title: '',
								message: `Failed to create group ${action.payload.name}.`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									enableHtml: true,
									timeOut: 5000,
								},
							}),
						];
					}),
				);
			}),
		),
	);

	adminCreateNewRole$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AdminCreateNewRole),
			switchMap((action: AdminCreateNewRole) => {
				return this.adminService.createRole(action.payload).pipe(
					mergeMap((roles: Role[]) => {
						const actions: Action[] = [
							new ToastUserNotification({
								type: 'success',
								title: '',
								message: `Role ${action.payload.name} was successfully created.`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									enableHtml: true,
									timeOut: 5000,
								},
							}),
							new SetRoles(roles),
						];

						return actions;
					}),
					catchError((error: any) => {
						return [
							new ToastUserNotification({
								type: 'error',
								title: '',
								message: `Failed to create role ${action.payload.name}.`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									enableHtml: true,
									timeOut: 5000,
								},
							}),
						];
					}),
				);
			}),
		),
	);

	getCityworksTransferMapping = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetCityworksTransferMap),
			switchMap(() => {
				return this.cityworksService.getCityworksTransferMapping().pipe(
					switchMap((response: CityworksTransferMapping[]) => {
						return [new SetCityworksTransferMap(response)];
					}),
					catchError((error: any) => {
						console.log(error);
						return [
							new SetCityworksTransferMap([]),
							new ToastUserNotification({
								type: 'error',
								title: 'Cityworks Mapping Retrieval Failure',
								message: `RAP failed to get the mapping details for problems that are Cityworks transferable.`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									enableHtml: true,
									timeOut: 5000,
								},
							}),
						];
					}),
				);
			}),
		),
	);

	cityworksRequestView$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CityworksRequestView),
			switchMap((action: CityworksRequestView) => {
				return this.cityworksService.getCityworksView(action.payload).pipe(
					switchMap((response: CityWorksRequestViewResponse) => {
						return [new CityworksRequestViewSuccess(response)];
					}),
					catchError((error: any) => {
						return [
							new CityworksRequestViewError({
								error,
								requestNo: action.payload,
							}),
						];
					}),
				);
			}),
		),
	);

	cityworksTransferRequestSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CityworksTransferRequestSuccess),
			switchMap((action: CityworksTransferRequestSuccess) => {
				let rapCaseNo = action.payload.caseNo;
				const actions: Action[] = [
					new GetDashBoardProblems({ problemNo: rapCaseNo }),
					new GetProblemLinkedCases({ caseNo: rapCaseNo }),
					new TransferringToCityworks(false),
					new ToastUserNotification({
						type: 'success',
						title: 'Transfer Completed',
						message: `RAP problem ${rapCaseNo} has been successfully transferred to Cityworks.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
			catchError((error: any) => {
				console.log(error);
				return [
					new ToastUserNotification({
						type: 'error',
						title: 'Problem Retrieval Error',
						message: `RAP problem failed to be retrieved after a transfer to Cityworks occurred.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];
			}),
		),
	);

	cityworksTransferRequestError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CityworksTransferRequestError),
			switchMap((action: CityworksTransferRequestError) => {
				console.log(action.payload.error);

				return [
					new TransferringToCityworks(false),
					new ToastUserNotification({
						type: 'error',
						title: 'Transfer Failed',
						message: `Failed to transfer problem ${action.payload.caseNo} to Cityworks.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];
			}),
		),
	);

	cityworksRequestViewError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CityworksRequestViewError),
			switchMap((action: CityworksRequestViewError) => {
				console.log(action.payload.error);

				return [
					new ToastUserNotification({
						type: 'error',
						title: 'Request View Failed',
						message: `Failed to query problem request no:${action.payload.requestNo} in Cityworks.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];
			}),
		),
	);

	cityworksTransferRequest$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CityworksTransferRequest),
			switchMap((action: CityworksTransferRequest) => {
				return this.cityworksService.transferToCityworks(action.payload).pipe(
					switchMap((response: any) => {
						return [
							new CityworksTransferRequestSuccess({
								caseNo: action.payload.caseNo,
								transferResponse: response,
							}),
						];
					}),
					catchError((error: any) => {
						// error is because it is not a cityworksTransferrableProblem
						if (error.status === 304) {
							return [new TransferringToCityworks(false)];
						}

						return [
							new CityworksTransferRequestError({
								caseNo: action.payload.caseNo,
								error,
							}),
						];
					}),
				);
			}),
		),
	);

	addCodeCase$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddCodeCase),
			withLatestFrom(this.store$),
			switchMap(([action, store]: [AddCodeCase, State]) => {
				return this.problemsService.addCodeCase(action.payload?.caseNumber, store.applicationReducer.arcGisToken.token).pipe(
					mergeMap((data: LinkedCase) => {
						const actions: Action[] = [new GetProblemLinkedCases(action.payload?.caseNumber), new AddCodeCaseSuccess(data)];

						return actions;
					}),
					catchError((error: any) => {
						return of(new AddCodeCaseError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	addCodeCaseSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddCodeCaseSuccess),
			mergeMap((action: AddCodeCaseSuccess) => {
				const actions: Action[] = [
					new GetProblems({ problemNo: action.payload?.problemOneNumber }), // This is to allow the new case status to update
					new GetActivities(action.payload?.problemOneNumber),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Code case has been created in EnerGov: ' + action.payload?.problemTwoNumber,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new AddProblemLinkedCaseSuccessToastMsg({ msg: 'Energov' }),
					new CreatingCodeCase(false),
				];

				return actions;
			}),
		),
	);

	addCodeCaseError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddCodeCaseError),
			mergeMap((action: AddCodeCaseError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: action.payload?.error ? action.payload?.error.error : 'Failed to create a code case.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new CreatingCodeCase(false),
				];

				return actions;
			}),
		),
	);

	addPermit$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddPermit),
			withLatestFrom(this.store$),
			switchMap(([action, store]: [AddPermit, State]) => {
				return this.problemsService
					.addPermit(action.payload?.caseNumber, action.payload?.permitType!, store.applicationReducer.arcGisToken.token)
					.pipe(
						mergeMap((data: LinkedCase) => {
							const actions: Action[] = [new GetProblemLinkedCases(action.payload?.caseNumber), new AddPermitSuccess(data)];

							return actions;
						}),
						catchError((error: any) => {
							return of(new AddPermitError(Object.assign({}, action.payload!, { error: error })));
						}),
					);
			}),
		),
	);

	addPermitSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddPermitSuccess),
			mergeMap((action: AddPermitSuccess) => {
				const actions: Action[] = [
					new GetProblems({ problemNo: action.payload?.problemOneNumber }), // This is to allow the new case status to update
					new GetActivities(action.payload?.problemOneNumber),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Permit has been created in EnerGov: ' + action.payload?.problemTwoNumber,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new AddProblemLinkedCaseSuccessToastMsg({ msg: 'Energov' }),
					new CreatingCodeCase(false),
				];

				return actions;
			}),
		),
	);

	addPermitError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddPermitError),
			mergeMap((action: AddPermitError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: action.payload?.error ? action.payload?.error.error : 'Failed to create a permit.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new CreatingCodeCase(false),
				];

				return actions;
			}),
		),
	);

	updateActivityClose$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateActivityClose),
			switchMap((action: UpdateActivityClose) =>
				this.activityService.updateActivity(action.payload!).pipe(
					map((data: ActivityList[]) => {
						return new GetTask({ activityNo: action.payload?.activityNo });
					}),
					catchError((error: any) => {
						return of(new UpdateActivityError(Object.assign({}, action.payload!, { error: error })));
					}),
				),
			),
		),
	);

	updateActivity$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateActivity),
			concatMap((action: UpdateActivity) =>
				this.activityService.updateActivity(action.payload!).pipe(
					map((data: ActivityList[]) => {
						// action.payload?.success = data;
						return new UpdateActivitySuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new UpdateActivityError(Object.assign({}, action.payload!, { error: error })));
					}),
				),
			),
		),
	);

	updateActivitySuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateActivitySuccess),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [UpdateActivitySuccess, State]) => [
				new SetInProgressActivity(false),
				new SetInProgressMyTask(false),
				new SetActivities(action.payload?.success),
				new GetTasks(),
				new GetProblems({ problemNo: store.routerReducer.state.queryParams.ProblemNo }),
				new ToastUserNotification({
					type: 'success',
					title: '',
					message: 'Activity is successfully updated.',
					options: {
						disableTimeOut: false,
						closeButton: true,
						enableHtml: true,
						timeOut: 5000,
					},
				}),
			]),
		),
	);

	updateActivityError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateActivityError),
			mergeMap((action: UpdateActivityError) => {
				const actions = [
					new SetInProgressActivity(false),
					new SetInProgressMyTask(false),
					new ToastUserNotification({
						type: 'error',
						title: 'Error',
						message: 'An error occured while trying to update activity ' + action.payload?.error!.message + '; Please try again.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							timeOut: 5000,
						},
					}),
				];
				return actions;
			}),
		),
	);

	reassignProblem$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.ReassignProblem),
			concatMap((action: ReassignProblem) =>
				this.activityService.addReassignActivity(action.payload!).pipe(
					mergeMap((data: ActivityList) => {
						// return new ReassignProblemSuccess(Object.assign({}, action.payload!, { success: data }));
						const actions: Action[] = [
							new CityworksTransferRequest({ caseNo: action.payload.caseNo }),
							new ReassignProblemSuccess(Object.assign({}, action.payload!, { success: data })),
						];

						return actions;
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new ReassignProblemError(Object.assign({}, action.payload!, { error: error })));
					}),
				),
			),
		),
	);

	reassignProblemSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.ReassignProblemSuccess),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [ReassignProblemSuccess, State]) => {
				const user = getUserFromState(store.applicationReducer, action.payload?.user_RefId!);
				const role = getRoleFromState(store.applicationReducer, action.payload?.role_RefId!);
				const userName = user !== null ? user.firstName + ' ' + user.lastName : role !== null ? role.name : 'Unassigned';

				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: action.payload?.caseNo + ' reassigned to ' + userName,
						options: {
							disableTimeOut: false,
							closeButton: true,
							timeOut: 5000,
						},
					}),
				];

				if (!action.payload?.assignToMe) {
					actions.unshift(new RedirectPath(['/dashboard']));
				} else {
					actions.unshift(new GetProblems({ problemNo: action.payload?.caseNo }));
					actions.push(new GetActivities(action.payload?.caseNo));
				}

				return actions;
			}),
		),
	);

	reassignProblemError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.ReassignProblemError),
			mergeMap((action: ReassignProblemError) => {
				const actions = [
					new GetProblems({ problemNo: action.payload?.caseNo }),
					new ToastUserNotification({
						type: 'error',
						title: 'Error',
						message: 'An error occured while trying to reassign problem ' + action.payload?.caseNo + '; Please try again.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							timeOut: 5000,
						},
					}),
					new GetActivities(action.payload?.caseNo),
				];
				return actions;
			}),
		),
	);

	/*  @Effect()
   ReassignGroupProblem$ = this.actions$.pipe(
     ofType(ApplicationActionType.ReassignGroupProblem),
     concatMap((action: ReassignGroupProblem) =>
       this.activityService.addReassignGroupActivity(action.payload!).pipe(
         map((data: ActivityList) => {
           action.payload?.success = data;
           return new ReassignGroupProblemSuccess(action.payload!);
         }),
         catchError((error: any) => {
           action.payload?.error = error;
           return of(new ReassignGroupProblemError(error));
         })
       )
     )
   );


   @Effect()
   ReassignGroupProblemSuccess$ = this.actions$.pipe(
     ofType(ApplicationActionType.ReassignGroupProblemSuccess),
     withLatestFrom(this.store$),
     mergeMap(([action, store]: [ReassignGroupProblemSuccess, State]) => {
       const group = getGroupFromState(store.applicationReducer, action.payload?.problemType_RefId);
       const groupName = group ? group.name : '';

       const actions: Action[] = [
         new RedirectPath(['/dashboard']),
         new ToastUserNotification({
           type: 'success',
           title: '',
           message: action.payload?.caseNo + ' reassigned to ' + groupName,
           options: {
             disableTimeOut: false,
             closeButton: true,
             enableHtml: true,
             timeOut: 5000
           }
         })
       ];

       return actions;
     })
   );

   @Effect()
   ReassignGroupProblemError$ = this.actions$.pipe(
     ofType(ApplicationActionType.ReassignGroupProblemError),
     mergeMap((action: ReassignGroupProblemError) => {
       const actions = [
         new GetProblems(action.payload?.caseNo),
         new ToastUserNotification({
           type: 'error',
           title: 'Error',
           message: 'An error occured while trying to reassign problem ' + action.payload?.caseNo + '; Please try again.',
           options: {
             disableTimeOut: false,
             closeButton: true,
             enableHtml: true,
             timeOut: 5000
           }
         }),
         new GetActivities(action.payload?.caseNo)
       ];
       return actions;
     })
   ); */

	addProblem$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblem),
			concatMap((action: AddProblem) => this.problemsService.addProblem(action.payload!)),
			// TODO
			mergeMap((newProblem: { caseNo: string; department: string; user: string; role: string }) => [
				new CityworksTransferRequest({ caseNo: newProblem.caseNo }),
				new SetNewCaseNo(newProblem),
				//  new GetCategorySubType(),
				new SetSelectedProblemType({ problemType_Id: 0, problemType_Name: 'Add a Problem' }),
			]),
		),
	);

	getAllSubTypes$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetAllProblemSubTypes),
			concatMap(() => this.problemsService.getAllProblemSubTypes()),
			mergeMap((subTypes: SelectedProblemSubType[]) => [new SetAllProblemSubTypes(subTypes)]),
		),
	);

	duplicateProblem$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DuplicateProblem),
			switchMap((action: DuplicateProblem) => {
				return this.problemsService.duplicateProblem(action.payload).pipe(
					switchMap((newProblem: { caseNo: string; department: string; user: string; role: string }) => {
						console.log(newProblem);
						const actions: Action[] = [
							new DuplicateProblemSuccess(newProblem),
							new CityworksTransferRequest({ caseNo: newProblem.caseNo, originalCaseNo: action.payload.originalProblemNo }),
							new GetProblemLinkedCases({ caseNo: action.payload.originalProblemNo }),
							new GetActivities(action.payload.originalProblemNo),
						];

						return actions;
					}),
					catchError((error: any) => {
						return of(new DuplicateProblemError(error));
					}),
				);
			}),
		),
	);

	duplicateProblemSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DuplicateProblemSuccess),
			switchMap((action: DuplicateProblemSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: 'Case successfully duplicated',
						message: `View in the Linked Cases section for problem ${action.payload.caseNo} of the Problem Details page.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	duplicateProblemError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DuplicateProblemError),
			switchMap((action: DuplicateProblemError) => {
				console.log(action.payload);
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: 'Problem failed to duplicate',
						message: `This problem duplicate has failed. Please try again.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	closeProblem$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CloseProblem),
			switchMap((action: CloseProblem) => {
				return this.problemsService.closeProblem(action.payload.problemId, action.payload.resolution).pipe(
					switchMap((closedProblem: { problemId: string[]; resolution: string }) => {
						console.log(closedProblem);
						const actions: Action[] = [new CloseProblemSuccess()];

						return actions;
					}),
					catchError((error: any) => {
						return of(new CloseProblemError(error));
					}),
				);
			}),
		),
	);

	closeProblemSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CloseProblemSuccess),
			switchMap((action: CloseProblemSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: 'Case(s) successfully closed',
						message: ``,
						options: {
							disableTimeOut: false,
							closeButton: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	closeProblemError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CloseProblemError),
			switchMap((action: CloseProblemError) => {
				console.log(action.payload);
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: 'Problem failed to close',
						message: `Please try again.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	toastUserNotification$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(ApplicationActionType.ToastUserNotification),
				map((action: ToastUserNotification) => {
					const notification: UserNotification = action.payload!;
					if (notification) {
						switch (notification.type) {
							case 'success':
								this.toastr.success(notification.message, notification.title, notification.options || {});

								break;
							case 'info':
								this.toastr.info(notification.message, notification.title, notification.options || {});

								break;
							case 'warning':
								this.toastr.warning(notification.message, notification.title, notification.options || {});

								break;

							case 'error':
								this.toastr.error(notification.message, notification.title, notification.options || {});

								break;
							default:
								this.toastr.error(
									notification.message ||
										'Please raise a suport ticket with information about what you were doing in the application!',
									notification.title || 'Something went wrong...',
									notification.options || {},
								);
								break;
						}
					} else {
						this.toastr.error(
							'Please raise a suport ticket with information about what you were doing in the application!',
							'Something went wrong...',
							{},
						);
					}
				}),
			),
		{ dispatch: false },
	);

	redirectPath$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(ApplicationActionType.RedirectPath),
				switchMap((action: RedirectPath) => this.router.navigate(action.payload!)),
			),
		{ dispatch: false },
	);

	getProblemHistory$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemHistory),
			switchMap((action: GetProblemHistory) =>
				this.problemsService.getProblemHistory(action.payload!).pipe(
					map((data: History[]) => new GetProblemHistorySuccess(data)),
					catchError((error: any) => of(new GetProblemHistoryError(error))),
				),
			),
		),
	);

	updateProblem = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateProblem),
			switchMap((action: UpdateProblem) => this.problemsService.updateProblem(action.payload!)),

			mergeMap((currentProblem: any) => {
				if (currentProblem != null) {
					return [
						new GetProblems({ problemNo: currentProblem.caseNo }),
						new GetDescriptionHistory(currentProblem.caseNo),
						new ToastUserNotification({
							type: 'success',
							title: '',
							message: 'This problem has been updated',
							options: {
								disableTimeOut: false,
								closeButton: true,
								timeOut: 5000,
							},
						}),
					];
				} else {
					return [];
				}
			}),
		),
	);

	getDescriptionHistory$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetDescriptionHistory),
			switchMap((action: GetDescriptionHistory) => this.problemsService.getProblemDescriptionHistory(action.payload!)),
			mergeMap((data) => [new SetDescriptionHistory(data)]),
		),
	);

	addProblemContacts$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblemContacts),
			switchMap((action: AddProblemContacts) => {
				return this.problemsService.addContact(action.payload!).pipe(
					map((data: ProblemContact[]) => {
						return new AddProblemContactsSuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						return of(new AddProblemContactsError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	addProblemContactsSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblemContactsSuccess),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [AddProblemContactsSuccess, State]) => {
				const problemNo = store.applicationReducer.problems.find((p) => p.problemId === action.payload?.problem_Id)!.problemNo;
				const actions: Action[] = [
					new GetProblems({ problemNo: problemNo }),
					new SetProblemContacts(action.payload?.success),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: action.payload?.contacts.length + ' contact(s) have been added.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	addProblemContactsError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddProblemContactsError),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [AddProblemContactsError, State]) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to add contacts.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	updateContact = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateContact),
			switchMap((action: UpdateContact) => {
				// console.log(action.payload!);
				const contacts = this.problemsService.updateContact(action.payload?.contact!);
				return forkJoin([contacts, of(action.payload?.problemNo!)]);
			}),
			// mergeMap((data: [ProblemContact[], string]) => {
			mergeMap((data: any[]) => {
				return [
					new GetProblems({ problemNo: data[1] }),
					new SetProblemContacts(data[0]),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'The contact has been updated',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];
			}),
		),
	);

	deleteContact$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteContact),
			switchMap((action: DeleteContact) => {
				return this.problemsService.deleteContact(action.payload!).pipe(
					map((data: ProblemContact[]) => {
						// action.payload?.success = data;
						return new DeleteContactSuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(new DeleteContactError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	deleteContactSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteContactSuccess),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [DeleteContactSuccess, State]) => {
				const problemNo = store.applicationReducer.problems.find((p) => p.problemId === action.payload?.problem_Id)!.problemNo;
				const actions: Action[] = [
					new GetProblems({ problemNo: problemNo }),
					new SetProblemContacts(action.payload?.success),
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Contact has been deleted.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	deleteContactError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteContactError),
			withLatestFrom(this.store$),
			mergeMap(([action, store]: [DeleteContactError, State]) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to delete contact.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	searchCoordinates$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SearchCoordinates),
			switchMap((action: SearchCoordinates) => {
				if (action.payload?.type === SearchItemType.StreetName) {
					return this.locationService.getStreetGeometry(action.payload!).pipe(
						mergeMap((data: any) => {
							const url = new Date().toISOString(); // create a unique url for each search result
							return [
								new SetMapGeoJsonLayers([
									{
										url: url,
										json: data,
									},
								]),
								new ZoomToGeoJsonLayer(url),
							];
						}),
						catchError((error: HttpErrorResponse) => {
							return of(
								new SearchCoordinatesError({
									...action.payload!,
									error: error,
								}),
							);
						}),
					);
				} else {
					return this.locationService.getLocationCoordinates(action.payload!).pipe(
						withLatestFrom(this.store$),
						mergeMap(([data, store]: [LocationCoordinate, State]) => {
							// mergeMap((data: LocationCoordinate) => {
							const latLng: DnvLatLng = {
								lat: data.lat,
								lng: data.lng,
							};
							const sfc: DnvMapInfo = {
								latlng: latLng,
								mapSizeInPixel: '803, 600',
								mapBounds: {
									northWestBound: store.mapState.northWestBound,
									southEastBound: store.mapState.southEastBound,
								},
							};

							const searchCoordinatesPayload: SearchCoordinatesPayload = {
								...action.payload!,
								updatedBy: 'Input',
								success: data,
							};
							return [
								new LookupOwnerAddress({
									ltopid: action.payload?.name,
								}),
								new SetMarkers([]),
								new SetMapGeoJsonLayers([]), // clear any potential street GeoJson
								// new SetSearchCoordinates(searchCoordinatesPayload),
								new SearchCoordinatesSuccess(searchCoordinatesPayload),
								new SetZoneLookupOnly(true),
								new DelayedActionBy1([
									new SearchFromCoordinates({
										problemMenu: action.payload?.problemMenu,
										dnvMapInfo: sfc,
										zoneLookupOnly: false,
										updatedBy: 'Input',
									}),
								]),
							];
						}),
						catchError((error: HttpErrorResponse) => {
							return of(
								new SearchCoordinatesError({
									...action.payload!,
									// updatedBy: null,
									error: error,
								}),
							);
						}),
					);
				}
			}),
		),
	);

	searchFromCoordinates$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SearchFromCoordinates),
			distinctUntilChanged((prev: SearchFromCoordinates, curr: SearchFromCoordinates) => {
				return (
					prev?.payload?.dnvMapInfo?.latlng?.lat === curr?.payload?.dnvMapInfo?.latlng?.lat &&
					prev?.payload?.dnvMapInfo?.latlng?.lng === curr?.payload?.dnvMapInfo?.latlng?.lng
				);
			}),
			withLatestFrom(this.store$),
			switchMap(([action, store]: [SearchFromCoordinates, State]) =>
				this.locationService.getLocationFromCoordinates(store.applicationReducer.arcGisToken.token, action.payload?.dnvMapInfo).pipe(
					mergeMap((data: SearchLocation[]) => {
						const reserve = data.filter((r) => r.locationType === 'Indian Reserve Boundaries')[0];

						if (data.length > 0 && data[0].location.includes('Out of Boundary')) {
							const actions: Action[] = [
								new IsNation(''),
								new ToastUserNotification({
									type: 'error',
									title: 'Error',
									message: 'Location is Out of Boundary',
									options: {
										disableTimeOut: false,
										closeButton: true,
										enableHtml: true,
										timeOut: 5000,
									},
								}),
								new SetMarkers([]),
							];

							return actions;
						} else if (data.length > 0 && reserve) {
							if (action.payload?.problemMenu && reserve.location.includes('5')) {
								const actions: Action[] = [
									new IsNation('Squamish'),
									new ToastUserNotification({
										type: 'warning',
										title: 'Warning',
										// message: 'This service is provided by squamish nation.',
										message: 'This location is outside the District of North Vancouver.',
										options: {
											disableTimeOut: false,
											closeButton: true,
											enableHtml: true,
											timeOut: 5000,
										},
									}),
									new SetMarkers([]),
								];

								return actions;
							} else if (action.payload?.problemMenu && reserve.location.includes('2') && action.payload?.problemMenu.isSNation) {
								const actions: Action[] = [
									new IsNation('Squamish'),
									new ToastUserNotification({
										type: 'warning',
										title: 'Warning',
										// message: 'This service is provided by squamish nation.',
										message: 'This location is outside the District of North Vancouver.',
										options: {
											disableTimeOut: false,
											closeButton: true,
											enableHtml: true,
											timeOut: 5000,
										},
									}),
									new SetMarkers([]),
								];

								return actions;
							} else if (action.payload?.problemMenu && reserve.location.includes('3') && action.payload?.problemMenu.isTWNation) {
								const actions: Action[] = [
									new IsNation('TW'),
									new ToastUserNotification({
										type: 'warning',
										title: 'Warning',
										// message: 'This service is provided by Tsleil-Waututh Nation.',
										message: 'This location is outside the District of North Vancouver.',
										options: {
											disableTimeOut: false,
											closeButton: true,
											enableHtml: true,
											timeOut: 5000,
										},
									}),
									new SetMarkers([]),
								];

								return actions;
							}
						}

						const locationType: string[] = [
							'DNV Parks',
							'Building',
							'Parcels',
							'Intersection Buffer',
							'Street Centerline Buffer',
							'DNV Boundary',
							'MetroVan Boundary',
						];

						const results = [...data];
						const searchText = store.applicationReducer.searchCoordinate?.name;
						if (searchText) {
							// Move the searchText options to the top of the list, so they can be used as first choice
							results.sort((a, b) => {
								return a.location == searchText ? -1 : b.location == searchText ? 1 : 0;
							});
						}
						const nameSearchLocation: SearchLocation | undefined = locationType
							.map((lt) => results.find((sl) => sl.locationType === lt))
							.find((x) => x && x.location !== 'Null');

						const name = nameSearchLocation ? nameSearchLocation.location : 'Unknown Location';

						// const name: string = data.find(l => l.locationType === 'DNV Parks') ?
						//   data.find(l => l.locationType === 'DNV Parks').location : data[0].location;
						const ltopid: string = data.find((l) => l.locationType === 'ltopid' && l.location !== 'Null')
							? data.find((l) => l.locationType === 'ltopid')!.location
							: '_unknown_pid_';

						const dblink: string = data.find((l) => l.locationType === 'dblink' && l.location !== 'Null')
							? data.find((l) => l.locationType === 'dblink')!.location
							: '_unknown_dblink_';

						const searchCoordinatesPayload: SearchCoordinatesPayload = {
							id: 0,
							name: name,
							type: SearchItemType.Unknown,
							searchLocation: data,
							updatedBy: action.payload?.updatedBy ? action.payload?.updatedBy : 'Click',
							success: {
								lat: action.payload?.dnvMapInfo.latlng.lat,
								lng: action.payload?.dnvMapInfo.latlng.lng,
								ltopid: ltopid,
								dblink: dblink,
							},
						};

						// action.payload?.success = t;
						const actions1: Action[] = [];
						actions1.push(new SearchFromCoordinatesSuccess(Object.assign({}, action.payload!, { success: searchCoordinatesPayload })));

						if (store.applicationReducer.propertyOwners.length === 0) {
							actions1.push(new LookupOwner(searchCoordinatesPayload.success));
						}

						return actions1;
					}),
					catchError((error: any) => {
						// action.payload?.error = error;
						return of(
							new SearchFromCoordinatesError(Object.assign({}, action.payload!, { error: error })), // TODO - handle
						);
					}),
				),
			),
		),
	);

	searchFromCoordinatesSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SearchFromCoordinatesSuccess),
			mergeMap((action: SearchFromCoordinatesSuccess) => {
				let marker: DnvMarker;
				const latLng: DnvLatLng = {
					lat: action.payload?.success!.success!.lat,
					lng: action.payload?.success!.success!.lng,
				};

				marker = {
					url: new Date().toISOString(), // create a unique url
					centerPoint: latLng,
					popup: '',
					popupOptions: { maxWidth: 400 },
					tooltip: action.payload?.success!.name,
					tooltipOptions: {
						permanent: false,
						direction: 'right',
						offset: [14, -20],
						className: 'map-tooltip',
					},
					clickEvent: true,
					id: action.payload?.success!.name,
					isActive: false,
					activeIcon: {
						iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
						className: 'myDivIconSelected',
						iconSize: [35, 60],
					},
					icon: {
						iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
						className: 'myDivIcon',
						iconSize: [35, 60],
					},
				};
				// this.store.dispatch(new SetMarkers([marker]));
				const actions: Action[] = [];

				actions.push(new IsNation(''));
				if (!action.payload?.zoneLookupOnly) {
					// actions.push(new SetSearchCoordinates(action.payload?.success));
					actions.push(new SetMarkers([marker]));
					actions.push(new SearchCoordinatesSuccess(action.payload?.success));
				} else {
					// buildProblem function in add-case requires SearchCoordinate to be populated.
					// this is required for problem assignment to work based on GIS east and west.
					actions.push(new SetSearchCoordinates(action.payload?.success));
				}

				return actions;
			}),
		),
	);

	checkTokenOnMapAction$ = createEffect(() =>
		this.actions$.pipe(
			ofType(...Object.values(DnvMapActionType)),
			throttleTime(1000),
			withLatestFrom(this.store$),
			switchMap(([action, store]: [Action, State]) => {
				// don't renew the token unless it is about to expire or already expired
				if (ArcGisTokenAboutToExpire(store.applicationReducer.arcGisToken)) {
					return [new RenewArcGisToken({ delayedActions: [] })];
				} else {
					return [];
				}
			}),
		),
	);

	// Similar to ArcgisInterceptor
	renewArcGisTokenEffect$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.RenewArcGisToken),
			withLatestFrom(this.store$),
			switchMap(
				([action, store]: [RenewArcGisToken, State]): Observable<any> => {
					// don't renew the token unless it is about to expire or already expired
					if (ArcGisTokenAboutToExpire(store.applicationReducer.arcGisToken)) {
						return this.arcGisService.RenewArcGisToken().pipe(
							mergeMap((data: ArcGisToken) => {
								const actions: Action[] = [];
								// update the token before performing the rest of the actions
								actions.push(
									new RenewArcGisTokenSuccess({
										delayedActions: action.payload?.delayedActions,
										success: data,
									}),
								);
								actions.push(new SetArcGisToken(data));
								actions.push(...action.payload?.delayedActions);
								return actions;
							}),
							catchError((error: HttpErrorResponse) => {
								return of(
									new RenewArcGisTokenError({
										delayedActions: [],
										error,
									}),
								);
							}),
						);
					} else {
						return [] as any;
					}
				},
			),
		),
	);

	searchCoordinatesSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SearchCoordinatesSuccess),
			mergeMap((action: SearchCoordinatesSuccess) => {
				// let marker: DnvMarker;
				// const latLng: DnvLatLng = {
				//   lat: action.payload?.success.lat,
				//   lng: action.payload?.success.lng
				// };

				// marker = {
				//   url: new Date().toISOString(), // create a unique url
				//   centerPoint: latLng,
				//   popup: '',
				//   popupOptions: { maxWidth: 400 },
				//   tooltip: action.payload?.name,
				//   tooltipOptions: {
				//     permanent: false,
				//     direction: 'right',
				//     offset: [14, -20],
				//     className: 'map-tooltip'
				//   },
				//   clickEvent: true,
				//   id: action.payload?.name,
				//   isActive: false,
				//   activeIcon: {
				//     iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
				//     className: 'myDivIconSelected',
				//     iconSize: [35, 60],
				//   },
				//   icon: {
				//     iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
				//     className: 'myDivIcon',
				//     iconSize: [35, 60],
				//   }
				// };

				// let ltopid = action.payload?.success.ltopid;
				// if (ltopid === undefined) {
				//   ltopid = '_unknown_pid_';
				// } else if (ltopid.length === 0) {
				//   ltopid = '_unknown_pid_';
				// }

				return [
					new SetSearchCoordinates(action.payload!),
					// new DelayedAction([new SetMarkers([marker])]),
					// new LookupOwner({
					//   ltopid: action.payload?.success.ltopid
					// })
				];
			}),
		),
	);

	lookupOwner$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.LookupOwner),
			switchMap((action: LookupOwner) =>
				this.locationService.getParcelOwner(action.payload?.ltopid).pipe(
					map((data: ContactDB[]) => {
						const t: LookupOwnerPayload = {
							ltopid: action.payload?.ltopid,
							success: data,
						};

						return new LookupOwnerSuccess(t);
					}),
					catchError((error: any) => {
						return of(
							new LookupOwnerError({
								ltopid: action.payload?.ltopid,
								error: error,
							}),
						);
					}),
				),
			),
		),
	);

	lookupOwnerAddress$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.LookupOwnerAddress),
			switchMap((action: LookupOwner) =>
				this.locationService.getParcelOwnerByAddress(action.payload?.ltopid).pipe(
					map((data: ContactDB[]) => {
						const t: LookupOwnerPayload = {
							ltopid: action.payload?.ltopid,
							success: data,
						};

						return new LookupOwnerSuccess(t);
					}),
					catchError((error: any) => {
						return of(
							new LookupOwnerError({
								ltopid: action.payload?.ltopid,
								error: error,
							}),
						);
					}),
				),
			),
		),
	);

	deletePreviousPropertyOwnerContacts$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeletePreviousPropertyOwnerContacts),
			withLatestFrom(this.store$),
			switchMap(([action, store]: [UpdateURLParams, State]) => {
				const owners: ProblemContact[] = store.applicationReducer.problemContacts.filter(
					(c) => c.contactType === 'Property Owner' && c.notes?.startsWith('Owner of '),
				);
				const problem = store.applicationReducer.problems[0];
				return [new DeleteContact({ problem_Id: problem.problemId, contacts: owners })];
			}),
		),
	);

	search$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.Search),
			withLatestFrom(this.store$),
			switchMap(([action, store]: [Search, State]) => {
				if (store.mapState.features.length > 0) {
					if (store.mapState.features[0].geometry.type === 'Polygon') {
						let polygonNum: number[][];
						const polygon: [[number, number]] = [[0, 0]];

						polygon.pop();

						// NEED TO REVIST THIS HERE
						// polygonNum = (store.mapState.features[0].geometry.coordinates as number[][][])[0].map(c => [...c]);
						polygonNum = ((store.mapState.features[0].geometry.coordinates as unknown) as number[][][])[0].map((c) => [...c]);

						polygonNum.map((coor) => polygon.push([coor[0], coor[1]]));

						polygon.push(polygon[0]);

						// Add additional first point as last point. Required by SQL Geography method.
						action.payload.polygon = polygon;
					}
				} else {
					action.payload.polygon = [[0, 0]];
				}
				return this.searchService.getSearchResults(action.payload!).pipe(
					mergeMap((data: any) => {
						const actions: Action[] = [];
						const linkedCases: LinkedCase[] = [];

						data.forEach((searchResult: SearchResultsPayload) => {
							searchResult.linkedCases.forEach((linkedCase: LinkedCase) => {
								if (!linkedCases.some((linkedProblem) => linkedProblem.problemLinked_Id === linkedCase.problemLinked_Id)) {
									linkedCases.push(linkedCase);
								}
							});
						});

						actions.push(
							new SearchResultsSuccess(data),
							new GetProblemLinkedCasesSucccess(linkedCases),
							new DelayedAction([new ScrollToResults(true)]),
						);

						const markers = this.setSearchMarkersInfo(data);

						if (markers.length > 0) {
							actions.push(new DelayedAction([new SetMarkers(markers), new SetNoMapLocation(false)]));
						} else {
							actions.push(new SetNoMapLocation(true));
						}

						return actions;
						// return actions.concat([
						// 	new SearchResultsSuccess(data),
						// 	new GetProblemLinkedCasesSucccess(linkedCases),
						// 	new DelayedAction([new ScrollToResults(true), new SetMarkers()]),
						// ]);
					}),
					catchError((error: HttpErrorResponse) => {
						return of(
							new SearchResultsError({
								...action.payload!,
								error: error,
							}),
						);
					}),
				);
			}),
		),
	);

	SearchResultsError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SearchResultsError),
			switchMap((action: SearchResultsError) => {
				const actions: Action[] = [];
				if (
					action.payload.error.error.indexOf(
						'A .NET Framework error occurred during execution of user-defined routine or aggregate "geography"',
					) > -1
				) {
					actions.push(
						new ToastUserNotification({
							type: 'error',
							title: '',
							message: `Lines in a polygon can't intersect, try redrawing.`,
							options: {
								disableTimeOut: false,
								closeButton: true,
								enableHtml: true,
								timeOut: 5000,
							},
						}),
					);
				}

				return actions;
			}),
		),
	);

	CancelActivity$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CancelActivity),
			switchMap((action: CancelActivity) => {
				return this.activityService.cancelActivity(action.payload?.problemNo, action.payload?.activityId).pipe(
					switchMap((data: ActivityList[]) => {
						const actions: Action[] = [
							new CancelActivitySuccess(data),
							new ToastUserNotification({
								type: 'success',
								title: '',
								message: `Activity No. ${action.payload?.activityNo} has been cancelled`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									timeOut: 5000,
								},
							}),
						];
						return actions;
					}),
					catchError((error: HttpErrorResponse) => {
						console.log(error);
						return of(new CancelActivityError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	CancelActivityError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.CancelActivityError),
			switchMap((action: CancelActivityError) => {
				const actions: Action[] = [
					new GetActivities(action.payload?.problemNo),
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: `Failed to cancel Activity No. ${action.payload?.activityNo}. Please try again.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	SaveSearchQuery$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SaveSearchQuery),
			withLatestFrom(this.store$),
			switchMap(([action, store]: [SaveSearchQuery, State]) => {
				if (store.mapState.features.length > 0) {
					if (store.mapState.features[0].geometry.type === 'Polygon') {
						let polygonNum: number[][];
						const polygon: [[number, number]] = [[0, 0]];

						polygon.pop();

						// NEED TO REVISIT THIS
						// polygonNum = (store.mapState.features[0].geometry.coordinates as number[][][])[0].map(c => [...c]);
						polygonNum = ((store.mapState.features[0].geometry.coordinates as unknown) as number[][][])[0].map((c) => [...c]);
						polygonNum.map((coor) => polygon.push([coor[0], coor[1]]));
						polygon.push(polygon[0]);

						// Add additional first point as last point. Required by SQL Geography method.
						action.payload.polygon = polygon.toString();
					}
				} else {
					action.payload.polygon = [[0, 0]].toString();
				}

				return this.searchService.addSearchQuery(action.payload!).pipe(
					switchMap((data: any) => {
						if (data.polygon) {
							data.polygon = [data.polygon.split(',')];
						}

						const actions: Action[] = [
							new SaveSearchQuerySuccess(data),
							new ToastUserNotification({
								type: 'success',
								title: '',
								message: `Search query ${data.savedQueryName} has been stored successfully`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									timeOut: 5000,
								},
							}),
						];

						return actions;
					}),
					catchError((error: HttpErrorResponse) => {
						console.log(error);
						return of(new SaveSearchQueryError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	saveSearchQueryError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SaveSearchQueryError),
			switchMap((action: SaveSearchQueryError) => {
				const actions: Action[] = [
					new GetAllSearchQueries(),
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: `Failed to save ${action.payload?.savedQueryName}. Please try again.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getAllSearchQueries$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetAllSearchQueries),
			switchMap(() => {
				return this.searchService.getSearchQueries().pipe(
					switchMap((data: any) => {
						if (data.polygon) {
							data.polygon = [data.polygon.split(',')];
						}
						return of(new GetAllSearchQueriesSuccess(data));
					}),
					catchError((error: HttpErrorResponse) => {
						console.log(error);
						return of(new GetAllSearchQueriesError());
					}),
				);
			}),
		),
	);

	getAllSearchQueriesError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetAllSearchQueriesError),
			switchMap(() => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: `Failed to pull saved queries. Please reload the page.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	removeSavedSearchQuery$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.RemoveSavedSearchQuery),
			switchMap((action: RemoveSavedSearchQuery) => {
				return this.searchService.deleteSavedSearchQuery(action.payload!).pipe(
					switchMap((data: any) => {
						const actions: Action[] = [
							new RemoveSavedSearchQuerySuccess(data),
							new ToastUserNotification({
								type: 'success',
								title: '',
								message: `Search query ${data.savedQueryName} has been removed successfully`,
								options: {
									disableTimeOut: false,
									closeButton: true,
									timeOut: 5000,
								},
							}),
						];

						return actions;
					}),
					catchError((error: HttpErrorResponse) => {
						console.log(error);
						return of(new RemoveSavedSearchQueryError(action.payload!));
					}),
				);
			}),
		),
	);

	removeSavedSearchQueryError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.RemoveSavedSearchQueryError),
			switchMap((action: RemoveSavedSearchQueryError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: `Failed to remove the ${action.payload?.savedQueryName} search query. Please reload and try again.`,
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	updateURLParams$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateURLParams),
			withLatestFrom(this.store$),
			switchMap(
				([action, store]: [UpdateURLParams, State]): Observable<any> => {
					let newUrl = this.router.url;
					const questionMarkIndex = this.router.url.indexOf('?');
					if (questionMarkIndex > -1) {
						newUrl = this.router.url.substring(0, questionMarkIndex);
					}

					newUrl += '?';

					queryParameterNames.forEach((field: SearchResultsPayloadTypes) => {
						newUrl += field + '=' + prop(action.payload!, field) + '&';
					});

					this.router.navigateByUrl(newUrl);

					return [] as any;
				},
			),
		),
	);

	updateAttachment$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UpdateAttachment),
			concatMap((action: UpdateAttachment) =>
				this.problemsService.updateAttachment(action.payload?.attachment).pipe(
					map((data: Attachment) => {
						if (action.payload?.attachment.attachment_Id === data.attachment_Id) {
							this.store$.dispatch(
								new ToastUserNotification({
									type: 'success',
									title: 'File Updated',
									message: 'File is successfully updated.',
									options: {},
								}),
							);

							action.payload.success = data;
							return new GetProblems({ problemNo: action.payload?.caseNo });
						} else {
							return new GetProblems({ problemNo: action.payload?.caseNo });
						}
					}),
					catchError((error: any) => {
						return of(
							new ToastUserNotification({
								type: 'error',
								title: 'Error',
								message: 'An error occured while trying to update the attachment ' + error.message + '; Please try again.',
								options: {
									disableTimeOut: false,
									closeButton: true,
									timeOut: 5000,
								},
							}),
						);
					}),
				),
			),
		),
	);

	private modal: NgbModalRef = null;

	uploadAttachments$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UploadAttachments),
			switchMap((action: Action) => {
				const uploadAttachmentsPayload: UploadAttachmentsPayload = (action as UploadAttachments).payload;
				this.modal = uploadAttachmentsPayload.modal;

				switch (uploadAttachmentsPayload.attachment.state) {
					case 'files':
						return from(uploadAttachmentsPayload.attachment.files).pipe(
							// Switched to concatMap instead of mergeMap so that uploads are performed sequentially.
							// For some reason, one of the uploads would always end up taking longer when performed in parallel.
							concatMap((file) => {
								const sendableFormData: FormData = new FormData();
								sendableFormData.append('attachment', file, file.name);
								sendableFormData.append('caseNo', uploadAttachmentsPayload.caseNo);
								sendableFormData.append('description', uploadAttachmentsPayload.description);
								return this.problemsService.uploadAttachment(sendableFormData).pipe(
									map((data: number) => {
										uploadAttachmentsPayload.success = { file: file, docNum: data };
										return new UploadDocumentSuccess(uploadAttachmentsPayload);
									}),
									catchError((error: any) => {
										uploadAttachmentsPayload.error = { file: file, error: error };
										return of(new UploadDocumentError(uploadAttachmentsPayload));
									}),
								);
							}),
						);
					case 'blob':
						const sendableFormData1: FormData = new FormData();
						sendableFormData1.append(
							'attachment',
							uploadAttachmentsPayload.attachment.files,
							'Case Summary for ' + uploadAttachmentsPayload.caseNo + '.pdf',
						);
						sendableFormData1.append('caseNo', uploadAttachmentsPayload.caseNo);
						sendableFormData1.append('description', uploadAttachmentsPayload.description);
						return this.problemsService.uploadAttachment(sendableFormData1).pipe(
							map((data: number) => {
								uploadAttachmentsPayload.success = {
									file: {
										name: 'Case Summary for ' + uploadAttachmentsPayload.caseNo + '.pdf',
									},
									docNum: data,
								};
								return new UploadDocumentSuccess(uploadAttachmentsPayload);
							}),
							catchError((error: any) => {
								uploadAttachmentsPayload.error = {
									file: {
										name: 'Case Summary for ' + uploadAttachmentsPayload.caseNo + '.pdf',
									},
									error: error,
								};
								return of(new UploadDocumentError(uploadAttachmentsPayload));
							}),
						);
				}
			}),
		),
	);

	uploadAttachmentSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UploadDocumentSuccess),
			mergeMap((action: UploadDocumentSuccess) => {
				if (this.modal) {
					this.modal.dismiss();
					this.modal = null;
				}
				const actions: Action[] = [
					// piggy backed on the same boolean.
					new CreatingCodeCase(false),
					new ToastUserNotification({
						type: 'success',
						title: 'File Uploaded',
						message: 'File ' + action.payload?.success.file.name + ' was successfully uploaded.',
						options: {},
					}),
					new GetProblems({ problemNo: action.payload?.caseNo }),
					new GetProblemAttachments(action.payload?.caseNo),
				];
				return actions;
			}),
		),
	);

	uploadAttachmentError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.UploadDocumentError),
			mergeMap((action: UploadDocumentError) => {
				if (this.modal) {
					this.modal.dismiss();
					this.modal = null;
				}
				const actions: Action[] = [
					// piggy backed on the same boolean.
					new CreatingCodeCase(false),
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to upload ' + action.payload?.error.file.name + '.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getProblemAttachments$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemAttachments),
			withLatestFrom(this.store$),
			switchMap(([action, store]: [GetProblemAttachments, State]) => {
				return this.problemsService.getProblemAttachments(action.payload!).pipe(
					mergeMap((data: Attachment[]) => {
						const imageTypes: string[] = ['gif', 'jpg', 'jpeg', 'png'];
						const actions: Action[] = [];
						const imageGallery = store.applicationReducer.galleryImages;
						actions.push(new GetProblemAttachmentsSuccess(data));
						data = data.filter((a: Attachment) => imageTypes.includes(a.fileType.toLowerCase()));
						if (data.length > 0) {
							imageGallery.forEach((image) => {
								data.forEach((i) => {
									if (i.docNumber.toString() === image.label) {
										const index = data.indexOf(i, 0);
										if (index > -1) {
											data.splice(index, 1);
										}
									}
								});
							});
							const docNums: string[] = data.map((i) => i.docNumber.toString());
							if (docNums.length > 0) {
								actions.push(new GetProblemAttachmentsImages({ caseNo: action.payload!, docNumbers: docNums }));
							}
						}

						return actions;
					}),
					catchError((error: HttpErrorResponse) => {
						return of(new GetProblemAttachmentsError(error.message));
					}),
				);
			}),
		),
	);

	getProblemAttachmentsImages$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemAttachmentsImages),
			switchMap((action: GetProblemAttachmentsImages) => {
				const newImages: NgxGalleryImage[] = [];
				return this.problemsService.downloadEdocsImage(action.payload?.caseNo, action.payload?.docNumbers).pipe(
					mergeMap((documents: EdocsDocument[]) => {
						const actions: Action[] = [];

						// if (documents.length !== action.payload?.attachmentImageCount) {
						//   actions.push(new GetProblemAttachmentsImagesPartialSuccess());
						// }

						documents.forEach((document: EdocsDocument) => {
							const blob = window.URL.createObjectURL(b64toBlob(document.data, 'image/' + document.fileType.toLowerCase(), 512));
							newImages.push({
								small: blob,
								medium: blob,
								big: blob,
								description: document.description,
								label: document.docNumber,
							});
						});

						actions.push(new SetProblemAttachmentsImages(newImages));
						return actions;
					}),
					catchError((error: HttpErrorResponse) => {
						const actions: Action[] = [
							new ToastUserNotification({
								type: 'error',
								title: '',
								message: 'Failed to retrieve gallery images. Please contact rap help administrator if this problem persists.',
								options: {
									disableTimeOut: false,
									closeButton: true,
									enableHtml: true,
									timeOut: 5000,
								},
							}),
						];

						return actions;
					}),
				);
			}),
		),
	);

	getProblemAttachmentsImagesPartialSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemAttachmentsImagesPartialSuccess),
			switchMap((action: GetProblemAttachmentsImagesPartialSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'warning',
						title: '',
						message: 'Image gallery is partially loaded. You may not have the necessary permission to view all images.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	getProblemAttachmentsImagesError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetProblemAttachmentsImagesError),
			switchMap((action: GetProblemAttachmentsImagesError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'You may not have the necessary permission to download this file.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	goToProblemDetails$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GoToProblemDetails),
			switchMap(
				(action: GoToProblemDetails): Observable<any> => {
					if (action.payload?.activityNo.length === 0 || action.payload?.activityNo === undefined) {
						this.router.navigate(['/problemdetails'], { queryParams: { ProblemNo: action.payload?.problemNo } });
					} else {
						this.router.navigate(['/problemdetails'], {
							queryParams: { ProblemNo: action.payload?.problemNo },
							fragment: action.payload?.activityNo,
						});
					}

					return [] as any;
				},
			),
		),
	);

	addWorkOrder$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddWorkOrder),
			switchMap((action: AddWorkOrder) => {
				return this.workOrderService
					.addWorkOrder(action.payload?.workOrderTypeRefId, action.payload?.activityId, action.payload?.activity)
					.pipe(
						map((data: WorkOrder) => {
							return new AddWorkOrderSuccess(Object.assign({}, action.payload!, { success: data }));
						}),
						catchError((error: AddWorkOrderError) => {
							return of(new AddWorkOrderError(Object.assign({}, action.payload!, { error: error })));
						}),
					);
			}),
		),
	);

	addWorkOrderSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddWorkOrderSuccess),
			mergeMap((data: AddWorkOrderSuccess) => {
				const actions: Action[] = [new UpdateActivity({ activityId: data.payload.activityId, activity: data.payload.activity })];

				return actions;
			}),
		),
	);

	addWorkOrderError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.AddWorkOrderError),
			mergeMap((data: AddWorkOrderError) => {
				const actions: Action[] = [
					new SetInProgressActivity(false),
					new ToastUserNotification({
						type: 'error',
						title: 'Work Order Creation Failed',
						message: data.payload.error.message,
						options: {},
					}),
				];

				return actions;
			}),
		),
	);

	submitWorkOrder$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SubmitWorkOrder),
			switchMap((action: SubmitWorkOrder) => {
				return this.workOrderService.submitWorkOrder(action.payload?.workOrderTypeRefId, action.payload?.activity).pipe(
					map((data: WorkOrder) => {
						return new SubmitWorkOrderSuccess(Object.assign({}, action.payload!, { success: data }));
					}),
					catchError((error: SubmitWorkOrderError) => {
						return of(new SubmitWorkOrderError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	submitWorkOrderSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SubmitWorkOrderSuccess),
			mergeMap((data: SubmitWorkOrderSuccess) => {
				const actions: Action[] = [
					new SetInProgressActivity(false),
					new GetProblems({ problemNo: data.payload.success.caseNo }), // To update the last updated at / by info
					new GetActivities(data.payload.success.caseNo),
					new ToastUserNotification({
						type: 'success',
						title: 'Work Order Created',
						message: 'Work Order #: ' + data.payload.success.workOrderNumber,
						options: {},
					}),
				];

				return actions;
			}),
		),
	);

	submitWorkOrderError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SubmitWorkOrderError),
			mergeMap((data: SubmitWorkOrderError) => {
				const actions: Action[] = [
					new SetInProgressActivity(false),
					new ToastUserNotification({
						type: 'error',
						title: 'Work Order Creation Failed',
						message: data.payload.error.message,
						options: {},
					}),
				];

				return actions;
			}),
		),
	);

	deleteWorkOrder$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteWorkOrderByActivityId),
			switchMap((action: DeleteWorkOrderByActivityId) => {
				return this.workOrderService.deleteWorkOrder(action.payload?.activityId).pipe(
					map((caseNo: string) => {
						return new DeleteWorkOrderByActivityIdSuccess(Object.assign({}, action.payload!, { success: caseNo }));
					}),
					catchError((error: DeleteWorkOrderByActivityIdError) => {
						return of(new DeleteWorkOrderByActivityIdError(Object.assign({}, action.payload!, { error: error })));
					}),
				);
			}),
		),
	);

	deleteWorkOrderSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteWorkOrderByActivityIdSuccess),
			mergeMap((data: DeleteWorkOrderByActivityIdSuccess) => {
				const actions: Action[] = [new UpdateActivity({ activityId: data.payload.activityId, activity: data.payload.activity })];

				return actions;
			}),
		),
	);

	deleteWorkOrderError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.DeleteWorkOrderByActivityIdError),
			mergeMap((data: DeleteWorkOrderByActivityIdError) => {
				const actions: Action[] = [
					new SetInProgressActivity(false),
					new ToastUserNotification({
						type: 'error',
						title: 'Work Order cancellation failed...',
						message: data.payload.error.message,
						options: {},
					}),
				];

				return actions;
			}),
		),
	);

	getDashboardView$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetDashboardView),
			switchMap((action: GetDashboardView) => {
				return this.problemsService.getDashboardView().pipe(
					map((data: string) => {
						return new GetDashboardViewSuccess(data);
					}),
					catchError((error: any) => {
						return of(new GetDashboardViewError(Object.assign({}, action.payload!, 'list')));
					}),
				);
			}),
		),
	);

	getDashboardSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetDashboardViewSuccess),
			switchMap((action: GetDashboardViewSuccess) => {
				const actions: Action[] = [new SetDashboardView(action.payload!)];

				return actions;
			}),
		),
	);

	getDashboardError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.GetDashboardViewError),
			mergeMap((action: GetDashboardViewError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to load user view setting. Defaulting to list view.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
					new SetDashboardView('list'),
				];

				return actions;
			}),
		),
	);

	saveDashboardView$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SaveDashboardView),
			switchMap((action: SaveDashboardView) => {
				return this.problemsService.saveDashboardView(action.payload!).pipe(
					map((data: string) => {
						return new SaveDashboardViewSuccess(data);
					}),
					catchError((error: any) => {
						return of(new GetDashboardViewError(Object.assign({}, action.payload!, 'list')));
					}),
				);
			}),
		),
	);

	saveDashboardSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SaveDashboardViewSuccess),
			switchMap((action: SaveDashboardViewSuccess) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'success',
						title: '',
						message: 'Dashboard view setting is set to ' + (action.payload! === 'maplist' ? 'map + list' : action.payload!) + '.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	saveDashboardError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApplicationActionType.SaveDashboardViewError),
			mergeMap((action: SaveDashboardViewError) => {
				const actions: Action[] = [
					new ToastUserNotification({
						type: 'error',
						title: '',
						message: 'Failed to save dashboard view setting.',
						options: {
							disableTimeOut: false,
							closeButton: true,
							enableHtml: true,
							timeOut: 5000,
						},
					}),
				];

				return actions;
			}),
		),
	);

	private setMarkersInfo(problems: Problem[], allProblemTypeList: ProblemType[], showToolTip: boolean) {
		const markers: DnvMarker[] = [];
		let marker: DnvMarker;

		for (let i = 0; i < problems.length; i++) {
			const problem = problems[i];

			marker = {
				url: problem.problemNo,
				centerPoint: problem.latLng,
				popup: '',
				popupOptions: { maxWidth: 400 },
				// tooltip: showToolTip ? allProblemTypeList.find(pt => pt.problemType_Id === problems[i].problemType_RefId).problemType_Name : '',
				tooltip: showToolTip ? problem.problemType_Name : '',
				tooltipOptions: {
					permanent: true,
					direction: 'right',
					offset: [14, -20],
					className: 'map-tooltip',
				},
				clickEvent: true,
				id: problem.problemNo,
				isActive: false,
				activeIcon: {
					iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
					className: 'myDivIconSelected',
					iconSize: [35, 60],
				},
				icon: {
					iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
					className: problems[i].problemRead === 'New' || problems[i].assignedTo === 'Unassigned' ? 'myDivIconUnRead' : 'myDivIcon',
					iconSize: [35, 60],
				},
			};
			markers.push(marker);
		}
		return markers;
	}

	private setSearchMarkersInfo(problems: SearchProblem[]) {
		const markers: DnvMarker[] = [];
		let marker: DnvMarker;
		for (let i = 0; i < problems.length; i++) {
			const problem = problems[i];
			if (problem.location_Latitude !== 0 && problem.location_Longitude !== 0) {
				marker = {
					url: problem.caseNumber,
					centerPoint: { lng: problem.location_Longitude, lat: problem.location_Latitude },
					popup: '',
					popupOptions: { maxWidth: 400 },
					tooltip: problem.caseNumber || '',
					tooltipOptions: {
						permanent: true,
						direction: 'right',
						offset: [14, -20],
						className: 'map-tooltip',
					},
					clickEvent: true,
					id: problem.caseNumber,
					isActive: false,
					activeIcon: {
						iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
						className: 'myDivIconSelected',
						iconSize: [35, 60],
					},
					icon: {
						iconFAUrl: '<i class="fas fa-map-marker-alt fa-3x"></i>',
						className: 'myDivIcon',
						iconSize: [35, 60],
					},
				};

				markers.push(marker);
			}
		}
		return markers;
	}

	// private b64toBlob(b64Data: string, contentType: string, sliceSize: number) {
	// 	const byteCharacters = atob(b64Data);
	// 	const byteArrays = [];
	// 	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	// 		const slice = byteCharacters.slice(offset, offset + sliceSize);

	// 		const byteNumbers = new Array(slice.length);
	// 		for (let i = 0; i < slice.length; i++) {
	// 			byteNumbers[i] = slice.charCodeAt(i);
	// 		}

	// 		const byteArray = new Uint8Array(byteNumbers);
	// 		byteArrays.push(byteArray);
	// 	}
	// 	const blob = new Blob(byteArrays, { type: contentType });
	// 	return blob;
	// }

	private setUserMap(data: MenuItem): Map<number, User> {
		// return new Map(data.allUsersList.map(obj => [obj.user_Id, obj]));
		return new Map(<[number, User][]>data.allUsersList.map((obj) => [obj.user_Id, obj]));
	}

	layerList(zoomLevel: number, layerState: LayerState): any {
		const activeFeatureLayers = layerState.layers
			.filter((l) => l.type === 0) // Only keep active layers
			// .filter(l => zoomLevel >= l.minZoom) // Only keep an active layer if the zoom level is high enough
			.map((l) => l.featureLayers);
		return this.myMergeMap(activeFeatureLayers);
	}

	myMergeMap(list: any[]): any {
		return list.reduce((accumulator, currentValue) => accumulator.concat(currentValue), []); // Poor man's MergeMap
	}

	constructor(
		private actions$: Actions,
		// tslint:disable-next-line: ngrx-no-typed-store
		private store$: Store<State>,
		private problemsService: ProblemsService,
		private activityService: ActivityService,
		private assetService: AssetService,
		private layerService: LayersService,
		private arcGisService: ArcGisService,
		private locationService: LocationService,
		private searchService: SearchService,
		private workOrderService: WorkOrderService,
		private adminService: AdminService,
		private cityworksService: CityworksService,
		private toastr: ToastrService,
		private router: Router,
		private authService: MsalService,
	) {}
}
